module.exports = require('@bugsnag/browser')



//////////////////
// WEBPACK FOOTER
// ./node_modules/@bugsnag/js/browser/notifier.js
// module id = WdoM
// module chunks = 0